import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Accordion from '../Accordion';
import Button from '../Button';
import Cta from '../Cta';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';

export default function PrivacyPolicyPage() {
    pageTitle('Privacy Policy');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const privacySections = [
        {
            title: 'Introduction',
            content: `At ACE, we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our services.`,
        },
        {
            title: 'Information We Collect',
            content: `We collect personal information, such as your name, email address, and payment details, that you provide when using our services. Additionally, we collect non-personal information, including browser type and website usage data, via cookies and analytics tools.`,
        },
        {
            title: 'How We Use Your Information',
            content: `Your information is used to deliver and improve our services, process transactions, and communicate effectively. With your consent, we may use your data for promotional and marketing purposes.`,
        },
        {
            title: 'Sharing Your Information',
            content: `We do not share or sell your personal information to third parties. However, we may share your information with trusted service providers (e.g., payment processors) as required to deliver our services.`,
        },
        {
            title: 'Cookies and Tracking Technologies',
            content: `We use cookies to enhance your browsing experience and analyze website usage. You can manage your cookie preferences through your browser settings.`,
        },
        {
            title: 'Data Security',
            content: `We employ industry-standard security measures to protect your information from unauthorized access or misuse. However, no system is entirely secure, and we cannot guarantee absolute data security.`,
        },
        {
            title: 'Your Rights',
            content: `You have the right to access, modify, or delete your personal data. You can also object to data processing for marketing purposes or withdraw your consent at any time.`,
        },
        {
            title: 'Policy Updates',
            content: `This Privacy Policy may be updated periodically. We encourage you to review this page regularly to stay informed of any changes.`,
        },
        {
            title: 'Contact Information',
            content: `For any privacy-related questions or concerns, please contact us using the information provided on our contact page.`,
        },
    ];

    return (
        <>
            <PageHeading
                title="Privacy Policy"
                bgSrc="/images/about_hero_bg.jpeg"
                pageLinkText="Privacy Policy"
            />
            <Spacing lg="150" md="80" />
            <Div className="container">
                <Div className="row">
                    {/* Sidebar */}
                    {/* Main Content */}
                    <Div className="col-lg-10">
                        <Spacing lg="0" md="40" />
                        {privacySections.map((section, index) => (
                            <Div key={index} id={section.title.replace(/\s+/g, '-').toLowerCase()}>
                                <h2 className="cs-privacy_title">{section.title}</h2>
                                <p>{section.content}</p>
                                <Spacing lg="40" md="20" />
                            </Div>
                        ))}
                    </Div>
                </Div>
            </Div>
            <Spacing lg="150" md="80" />

            {/* CTA Section */}
            <Div className="container">
                <Cta
                    title="Have questions about our <br /><i>Privacy Policy?</i>"
                    btnText="Contact Us"
                    btnLink="/contact"
                    bgSrc="/images/cta_bg.jpeg"
                />
            </Div>
        </>
    );
}
